import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { css } from 'glamor';

import { normalizeAuthor } from '../utilities/formatting';

export default ({ author }) => (
    <div>
        <StaticQuery
            query={graphql`
                query AvatarQuery {
                    aaron: file(relativePath: { eq: "avatars/aaron.jpg"}) {
                        childImageSharp {
                            fixed(width: 120, height: 120, quality: 100) {
                                ...GatsbyImageSharpFixed_withWebp_tracedSVG
                            }
                        }
                    }
                    cristian: file(relativePath: { eq: "avatars/cristian.jpg"}) {
                        childImageSharp {
                            fixed(width: 120, height: 120, quality: 100) {
                                ...GatsbyImageSharpFixed_withWebp_tracedSVG
                            }
                        }
                    }
                    stephen: file(relativePath: { eq: "avatars/stephen.jpg"}) {
                        childImageSharp {
                            fixed(width: 120, height: 120, quality: 100) {
                                ...GatsbyImageSharpFixed_withWebp_tracedSVG
                            }
                        }
                    }
                }
            `}
            render={(data) => {
                const image = data[normalizeAuthor(author)];
                if (!image) return null;

                return (
                    <Img
                        outerWrapperClassName={css({ display: 'inline-block' })}
                        css={{
                            marginRight: 20,
                            borderRadius: '50%',
                            height: 120,
                            width: 120,
                        }}
                        fixed={image.childImageSharp.fixed}
                        alt={author}
                    />
                );
            }}
        />
    </div>
);
